module.exports = __webpack_public_path__ + "img/zwdk.9d25eead.png";